import { render } from "./RedPack.vue?vue&type=template&id=0dd347ce&scoped=true"
import script from "./RedPack.vue?vue&type=script&lang=js"
export * from "./RedPack.vue?vue&type=script&lang=js"

import "./RedPack.vue?vue&type=style&index=0&id=0dd347ce&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd347ce"]])

export default __exports__